import React, { useState } from 'react'
import { ThumbFrame, ThumbImg } from './Thumbnail.styles'

interface ThumbnailProps {
	/** Preview image url; `null`/failed load → warm-tint icon-chip fallback. */
	url: string | null
	/** Accessible alt text for the image. */
	alt: string
	/** Warm-tint fallback icon (rendered when there is no usable image). */
	fallbackIcon: React.ReactNode
	className?: string
}

/**
 * A rounded media cell that renders `url` as a cover image, or falls back to a
 * warm-tint chip carrying the section icon when the image is missing or fails to
 * load. The single home for the "missing image → warm icon chip" rule the whole
 * bento relies on.
 */
const Thumbnail: React.FC<ThumbnailProps> = ({ url, alt, fallbackIcon, className }) => {
	const [failed, setFailed] = useState(false)
	// Derive-from-props reset: a new url gets a fresh attempt even when the
	// element is reused in place (no remount to clear the failure flag).
	const [prevUrl, setPrevUrl] = useState(url)
	if (url !== prevUrl) {
		setPrevUrl(url)
		setFailed(false)
	}

	const showImage = !!url && !failed

	return (
		<ThumbFrame className={className}>
			{showImage ? <ThumbImg src={url} alt={alt} loading="lazy" onError={() => setFailed(true)} /> : fallbackIcon}
		</ThumbFrame>
	)
}

export default Thumbnail
